import { GridApi, IRowNode } from 'ag-grid-community';
import { useAtomValue } from 'jotai';
import { useCallback, useEffect } from 'react';
import { InvestorCashFlowRow } from '../../../../schemas/InvestorCashFlows.schema';
import { investorCashFlowsTypeJ } from './state';

/** The investor-type toggle as an ag-grid external filter over the `Total` rows. */
export function useInvestorCashFlowsGridFilter(gridApi: GridApi | null) {
  const type = useAtomValue(investorCashFlowsTypeJ);

  const doesExternalFilterPass = useCallback(
    (node: IRowNode<InvestorCashFlowRow>) => {
      const { data } = node;
      if (!data) {
        return false;
      }
      // Expense rows belong to the fund, not an investor class, so they show under every type — as the API does.
      return type === 'Total' || data.investorType === type || data.nature === 'Expense';
    },
    [type]
  );

  const isExternalFilterPresent = useCallback(() => type !== 'Total', [type]);

  useEffect(() => {
    gridApi?.onFilterChanged();
  }, [type, gridApi]);

  return { doesExternalFilterPass, isExternalFilterPresent };
}
